<template>
  <div class="exam-page">
    <!-- 顶部区域 -->
    <div class="page-header">
      <h1 class="page-title">📝 在线答题</h1>
      <p class="page-subtitle">共 {{ exam_list.length }} 道题目</p>
    </div>

    <!-- 题目列表 -->
    <div class="question-container">
      <div
        class="question-card"
        v-for="(item, index) in exam_list"
        :key="item.Id"
        :style="{ animationDelay: index * 0.05 + 's' }"
      >
        <div class="question-header">
          <span class="question-number">{{ index + 1 }}</span>
          <span class="question-type" :class="getTypeClass(item.TopicType)">
            {{ item.TopicType }}
          </span>
        </div>

        <div class="question-title">
          {{ item.TopicName }}
          <span v-if="item.Category === 0 && ShowRightAnswer_ex" class="correct-answer">
            （正确答案：{{ item.IsRightAnswer }}）
          </span>
        </div>

        <!-- 单选题 -->
        <div v-if="item.TopicType === '单选题'" class="options-list">
          <van-radio-group v-model="item.Answer">
            <div
              class="option-item"
              v-for="option in item.TopicAnswerList"
              :key="option.Id"
              :class="{ 'option-selected': item.Answer === option.Number }"
              @click="item.Answer = option.Number"
            >
              <van-radio :name="option.Number" checked-color="#d51900">
                <span class="option-text">{{ option.Option }}</span>
              </van-radio>
            </div>
          </van-radio-group>
        </div>

        <!-- 多选题 -->
        <div v-if="item.TopicType === '多选题'" class="options-list">
          <van-checkbox-group v-model="item.Answer">
            <div
              class="option-item"
              v-for="option in item.TopicAnswerList"
              :key="option.Id"
              :class="{ 'option-selected': item.Answer && item.Answer.includes(option.Number) }"
            >
              <van-checkbox :name="option.Number" checked-color="#d51900" shape="square">
                <span class="option-text">{{ option.Option }}</span>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>

        <!-- 填空题 -->
        <div v-if="item.TopicType === '填空题'" class="fill-blank">
          <van-field
            v-model="item.Answer"
            rows="3"
            autosize
            type="textarea"
            placeholder="请输入您的答案"
            class="fill-input"
          />
        </div>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="submit-section">
      <van-button
        class="submit-btn"
        round
        block
        type="info"
        :loading="BTN_IF"
        loading-text="提交中..."
        @click="submit"
      >
        提交答案
      </van-button>
    </div>
  </div>
</template>

<script>
import { WeChatMemberExam_GetMemberExamTopicList, WeChatMemberExam_MemberAnswerPost } from '../api/api'

export default {
  name: 'examination',
  data () {
    return {
      exam_list: [],
      ShowRightAnswer_ex: false,
      ShowRightAnswer: false,
      BTN_IF: false
    }
  },
  async mounted () {
    this.ShowRightAnswer = this.$route.query.ShowRightAnswer
    const { data } = await WeChatMemberExam_GetMemberExamTopicList(this.$route.query)

    // 处理多选题答案格式
    const topicList = (data.response && data.response.TopicList) || []
    topicList.forEach(item => {
      if (item.TopicType === '多选题') {
        item.Answer = item.Answer ? item.Answer.split(',') : []
      }
    })

    this.exam_list = topicList
  },
  methods: {
    getTypeClass (type) {
      const typeMap = {
        '单选题': 'type-single',
        '多选题': 'type-multiple',
        '填空题': 'type-fill'
      }
      return typeMap[type] || 'type-single'
    },
    async submit () {
      if (this.BTN_IF) return

      // 验证必答题
      const unanswered = this.exam_list.filter(item => {
        if (item.Category !== 0) return false
        if (Array.isArray(item.Answer)) return item.Answer.length === 0
        return !item.Answer
      })

      if (unanswered.length > 0) {
        this.$toast('请完成所有必答题')
        return
      }

      this.BTN_IF = true

      // 构建提交数据
      const submitData = {
        TopicList: this.exam_list.map(item => ({
          ...item,
          Answer: Array.isArray(item.Answer) ? item.Answer.join(',') : item.Answer
        }))
      }

      const { data } = await WeChatMemberExam_MemberAnswerPost(submitData)

      if (data.status === 200) {
        this.$dialog({
          message: data.msg,
          confirmButtonColor: '#d51900'
        }).then(() => {
          if (data.response && data.response.ShowRightAnswer) {
            this.ShowRightAnswer_ex = true
          } else {
            this.$router.replace({ path: '/examination_list' })
          }
        })
      } else {
        this.$toast(data.msg)
      }

      this.BTN_IF = false
    }
  }
}
</script>

<style scoped>
.exam-page {
  min-height: 100vh;
  background: #f5f9fc;
  padding-bottom: 100px;
  /* 防止闪烁 - Android/iOS 兼容 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
}

/* 顶部区域 */
.page-header {
  background: #fff;
  padding: 20px 20px 10px;
  text-align: center;
  border-bottom: 1px solid #f0f4f8;
}

.page-title {
  font-size: 20px;
  font-weight: 800;
  color: #1a2a3a;
  margin: 0 0 4px;
  letter-spacing: 0.5px;
}

.page-subtitle {
  font-size: 13px;
  color: #8a9aaa;
  margin: 0;
}

/* 题目容器 */
.question-container {
  padding: 16px;
}

/* 题目卡片 */
.question-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  animation: fadeInUp 0.5s ease-out forwards;
  opacity: 0;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.question-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.question-number {
  width: 28px;
  height: 28px;
  background: #d51900;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  margin-right: 10px;
}

.question-type {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
}

.type-single {
  background: rgba(213, 25, 0, 0.1);
  color: #d51900;
}

.type-multiple {
  background: rgba(165, 94, 234, 0.1);
  color: #8854d0;
}

.type-fill {
  background: rgba(38, 222, 129, 0.1);
  color: #20bf6b;
}

.question-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a2a3a;
  line-height: 1.6;
  margin-bottom: 16px;
}

.correct-answer {
  color: #d51900;
  font-weight: 500;
}

/* 选项列表 */
.options-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option-item {
  background: #f8fbfd;
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 14px 16px;
  transition: all 0.3s ease;
}

.option-item:active {
  background: #f0f6fa;
}

.option-item.option-selected {
  background: rgba(213, 25, 0, 0.05);
  border-color: #d51900;
}

.option-text {
  font-size: 14px;
  color: #1a2a3a;
  line-height: 1.5;
}

/* 填空题 */
.fill-blank {
  margin-top: 4px;
}

.fill-input {
  background: #f8fbfd !important;
  border-radius: 12px !important;
  border: 2px solid #e8eef3 !important;
}

.fill-input:focus-within {
  border-color: #d51900 !important;
}

/* 提交按钮 */
.submit-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background: #ffffff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
}

.submit-btn {
  height: 50px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 2px;
  background: #d51900 !important;
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/examination.vue